import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCartPricingError, useCartPricingRefreshing } from '../../contexts/CartPricingContext';
import useAnimatedNumber from '../../hooks/useAnimatedNumber';
import * as types from '../../types';
import { useCartCheckout } from '../CartSummary/CartActions';
import useHardwareFirstTotals from './useHardwareFirstTotals';
import styles from './HardwareFirstCheckoutBar.module.scss';

interface HardwareFirstCheckoutBarProps {
  id?: string;
  onCheckOut: (checkoutCart: types.Cart, cartPricing: types.CartPricing) => void;
}

/** The mobile cart's pinned bar: the pre-tax subtotal and the route into checkout. */
export default function HardwareFirstCheckoutBar({ id, onCheckOut }: HardwareFirstCheckoutBarProps) {
  const { t } = useTranslation();
  const { hardwareInCents, trialInCents, discountInCents, totalInCents, formatPrice } = useHardwareFirstTotals();
  const checkout = useCartCheckout(onCheckOut);
  const refreshing = useCartPricingRefreshing();
  const shownTotalInCents = useAnimatedNumber(totalInCents, !refreshing);
  const pricingError = useCartPricingError();

  return (
    <div className={styles.bar} id={id}>
      <div className={styles.priceColumn}>
        <span className={classNames(styles.price, { [styles.pending]: refreshing })} aria-busy={refreshing}>
          <span className={styles.total}>{pricingError ? '—' : formatPrice(shownTotalInCents)}</span>
          {!pricingError && discountInCents > 0 && (
            <span className={styles.listPrice}>{formatPrice(hardwareInCents - trialInCents)}</span>
          )}
        </span>
        <span className={styles.dueToday}>{t('subtotal')}</span>
      </div>
      <button className={styles.checkoutButton} onClick={checkout} type="button">
        {t('checkout')}
      </button>
    </div>
  );
}
